import { useContext, useEffect, useRef } from 'react'
import { UserContext, UserContextType } from '../UserContext'
import { sleep } from '../utils'

/**
 * Fixes simple remote recording bug where if you join the room with audio output set to None
 * and a peer joins and you try to simple-remote-record them, the audio does not go out
 * through `audioOutputMuseRecording`.
 *
 * This is fixed by "cycling" the output audio to the `audioOutputMuseRecording` device
 * for a brief moment.
 */
export default function useSimpleRecordingInitialNoneAudioOutputFix({
    currPeerAudioOutputStream,
}: {
    currPeerAudioOutputStream: MediaStream | null
}) {
    const { state, dispatch } = useContext(UserContext) as UserContextType

    const _runOnceFlag = useRef(false)
    const _exclusionFlag = useRef(false)
    useEffect(() => {
        ;(async () => {
            const tag = `simple-remote-recording: cycling fix: `
            const audioOutput = state.mediaSelection.audioOutput
            const museRecording = state.mediaSelection.audioOutputMuseRecording
            if (!(currPeerAudioOutputStream instanceof MediaStream)) {
                return
            }
            if (museRecording === '_none' || museRecording === '_undef' || museRecording == null) {
                console.log(
                    tag + `set update_media_selection to museRecording="${museRecording}" is not set, so no-op.`
                )
                return
            }
            if (currPeerAudioOutputStream.getAudioTracks().length === 0) {
                return
            }
            if (!(audioOutput === '_none' || audioOutput === '_undef' || audioOutput == null)) {
                return
            }
            if (_runOnceFlag.current) {
                return
            }
            _runOnceFlag.current = true

            if (_exclusionFlag.current) {
                return
            }
            _exclusionFlag.current = true

            const saved = audioOutput
            console.log(tag + `set saved=${saved}`)

            console.log(
                tag + `set update_media_selection to mediaSelection.audioOutputMuseRecording=` + `"${museRecording}".`
            )
            dispatch({
                type: 'update_media_selection',
                value: {
                    audioOutput: museRecording,
                },
            })

            await sleep(50)

            console.log(tag + `unset update_media_selection to saved="${saved}"`)
            dispatch({
                type: 'update_media_selection',
                value: {
                    audioOutput: saved,
                },
            })

            _exclusionFlag.current = false
        })()
    }, [state.mediaSelection.audioOutputMuseRecording, currPeerAudioOutputStream])

    return {}
}
